import { getAxiosClientWithToken } from './index';

export const getServices = () => {
    const restClient = getAxiosClientWithToken();
    return restClient.get(`/company/services`);
};
